import { Button } from "@mui/material";

import { useTranslation } from "react-i18next";

import { useAppDispatch, useAppSelector } from "~/app/store";
import { mixpanelTrack, useMixpanelPageName } from "~/lib/mixpanel-tracking";

import { selectThisWorkstation } from "~/redux/selectors/workstationsSelectors";
import { useClosePortMutation } from "~/redux/warehouse/autostoreGrid.hooks";

import {
  clearBinOverrides,
  selectIsPreviousBinFlow
} from "./autostorePutaway.slice";

export const ClearBinOverridesButton = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const trackedPageName = useMixpanelPageName();

  const isPreviousBinFlow = useAppSelector(selectIsPreviousBinFlow);
  const siteWorkstation = useAppSelector(selectThisWorkstation);
  const forcedPortsForWholeBins = useAppSelector(
    (state) => state.autostorePutaway.wholeBinPortOverrides
  );

  const [closePort] = useClosePortMutation();

  const handleClick = async () => {
    if (!siteWorkstation) return;

    mixpanelTrack({
      trackedPageName,
      type: "Button Click",
      label: "Food Safety Complete",
      eventProperties: {
        "Whole Bin Port Overrides Closed": forcedPortsForWholeBins
      }
    });
    await Promise.all(
      forcedPortsForWholeBins.map((port) =>
        closePort({
          portId: port,
          autostoreGridId: siteWorkstation.autostoreGridId
        })
      )
    );

    dispatch(clearBinOverrides());
  };

  return (
    <Button
      variant="subtle"
      size="large"
      onClick={handleClick}
      disabled={isPreviousBinFlow}
    >
      {t("food safety complete")}
    </Button>
  );
};
